import React from 'react';
import { reminderHelpers } from './reminder-helpers';
import { ReminderName, ReminderScheduleText, ReminderTimePicker, TimeLabel } from './common-reminder-components';
import DropdownMain from "../../../../../../components/dropdown-main/DropdownMain";
import PropTypes from 'prop-types';

const RecurringReminders = ({ taskReminder, setTaskReminder }) => {

    return (
        <div data-testid='recurring-reminders'>
            <ReminderName taskReminder={taskReminder} setTaskReminder={setTaskReminder} />
            <TimeLabel />
            <div className="elements-container show">
                <div className="left-element" data-testid='dropdown-main'>
                    <DropdownMain                        
                        values={reminderHelpers.reminderRecurringValues}
                        dropdownButtonText={"-Select-"}
                        onSelect={(selectedValue) => {
                            reminderHelpers.handleChange(
                                "reminderRecurring",
                                selectedValue,
                                setTaskReminder
                            );
                        }}
                        currentSelected={taskReminder.reminderRecurring}
                        disabled={!taskReminder.exist}
                    />
                </div>
                <div className="mid-element"></div>

                <div className="right-element">
                    <ReminderTimePicker taskReminder={taskReminder} setTaskReminder={setTaskReminder} />
                </div>
            </div>
            {taskReminder.reminderRecurring.name === "Custom" && (
                <div className="elements-container">
                    <div className="left-element">
                        <div className="row-container">
                            <h4>Repeat every</h4>
                            <input
                                id="reminderDays"
                                data-testid="reminderDays"
                                name="reminderDays"
                                value={taskReminder.days}
                                type="number"
                                min={1}
                                required
                                onChange={(e) => {
                                    e.target.value =
                                        e.target.value == 0 ? 1 : e.target.value;
                                    reminderHelpers.handleChange(
                                        "days",
                                        e.target.value,
                                        setTaskReminder
                                    );
                                }}
                                onKeyDown={(e) => {
                                    (e.key === "Enter" ||
                                        e.key === "." ||
                                        e.key === "-") &&
                                        e.preventDefault();
                                }}
                                disabled={!taskReminder.exist}
                            />
                            <div className="row-dropdown" data-testid='dropdown-main2'>
                                <DropdownMain
                                    values={
                                        reminderHelpers.reminderRecurringIntervalTypeValues
                                    }
                                    dropdownButtonText={"-Select-"}
                                    onSelect={(selectedValue) => {
                                        reminderHelpers.handleChange(
                                            "reminderRecurringIntervalType",
                                            selectedValue,
                                            setTaskReminder
                                        );
                                    }}
                                    currentSelected={
                                        taskReminder.reminderRecurringIntervalType
                                    }
                                    disabled={!taskReminder.exist}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <ReminderScheduleText taskReminder={taskReminder} />
        </div>
    );
};


RecurringReminders.propTypes = {
    taskReminder: PropTypes.shape({
        exist: PropTypes.bool,
        reminderRecurring: PropTypes.shape({
            name: PropTypes.string,
        }),
        days: PropTypes.number,
        reminderRecurringIntervalType: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
        }),

    }),
    setTaskReminder: PropTypes.func.isRequired,
};

export default RecurringReminders;